export default {
  create_first_case: 'Добавить запись о происшествии',
  case: 'запись о происшествии',
  new_case: 'новая запись о происшествии',
  new_case_description: 'Вы создаёте новую запись о происшествии. Укажите её название, номер и дату КУСП (при наличии), а также фактическую дату происшествия',
  incident_date: 'Дата происшествия',
  record_id: 'Номер КУСП',
  record_id_short: 'КУСП',
  record_date: 'Дата КУСП',
  set_role_permissions: 'Установить права доступа',
  filter_all: 'все',
  filter_open: 'открытые',
  filter_archived: 'архивные',
  name: 'название',
  type: 'Тип',
  connections: 'связи',
  information: 'сведения',
  cluster: 'кластер',
  witness: 'Свидетель',
  victim: 'Потерпевший',
  suspect: 'Подозреваемый',
  irrelevant: 'Нерелевантный',
  comment: 'комментарий',
  related_cards: 'Соответствующие записи картотеки',
  related_participants: 'Соответствующие участники',
  clusters: 'Распознанные люди',
  participants: 'Участники',
  participants_in_current_case: 'Участники этого происшествия',
  participants_in_other_cases: 'Участники других происшествий',
  card_index: 'Картотека',
  wizard_help_text:
    'Вы анализируете изображение человека, автоматически распознанного при обработке видеоданных с места происшествия. Если данное лицо релевантно исследуемому происшествию, пометьте его как участника. Если вы уверены, что данное лицо совпадает с другими уникальными людьми в этом происшествии, или с записями картотеки, или с участниками других происшествий, установите соответствующую связь при помощи кнопки «Добавить»',
  create_new_participant: 'Отметить как участника',
  add: 'Добавить',
  save_and_done: 'Сохранить и закрыть',
  save_participant: 'Сохранить',
  case_id: 'ID происшествия',
  enter_case_id: 'Введите ID происшествия',
  participant_name: 'Имя участника',
  enter_participant_name: 'Введите имя участника',
  role: 'Роль',
  date_time_participant: 'Дата и время создания участника'
};
